export class Job {
    readonly id?: number

    location_id: number = -1

    customer_id: number = -1
    customer_location_id: number = -1
    credit_card_id?: number

    department_id: number = -1
    brand_id: number = -1
    type_id: number = -1

    source_id: number = -1

    date?: string
    start?: string
    end?: string
    call_before: number = 0
    service_call?: number

    priority: number = 0
    description: string = ''

    call_direction: number = 1
    recording_id?: string

    call_sid?: string
    equip_age?: number

    lost_reason_id?: number
}